<>
<template>
  <HelpItem/>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import HelpItem from "@/views/HelpItem.vue"

  export default {
    components: {
      HelpItem
    },
    data: () => ({}),
    created() {

    },
    computed: {},
    methods: {}
  }
</script>
